import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import appConfig from '@/config/appConfig.typed';
import analyticsEventValues from '@/consts/analytics/analyticsEventValues';
import {AUTO_DELIVERY_DETAILS_INACTIVE_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import amplitudeAutodeliveryTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {hideAutoDeliveryStatusInactiveDetailsPopup} from '@/state/slices/modalSlice';

import AutoDeliveryDetailsStatusNoneTemplate from './components/AutoDeliveryDetailsStatusNoneTemplate';

const AutoDeliveryStatusInactiveDetailsPopup = () => {
    const dispatch = useDispatch();
    const banner = appConfig.getAutoDeliveryDetailedBannerInactive();
    const benefitsList = appConfig.getAutoDeliveryStatusInactiveBenefitsIcons();
    const howItWorksList = appConfig.getAutoDeliveryStatusInactiveHowItWorksIcons();

    const amplitudeEvent = () => {
        amplitudeAutodeliveryTracking.trackAutoDeliveryOrderButtonClick(
            analyticsEventValues.REACTIVATE,
            analyticsEventValues.PAUSED
        );
        googleAnalyticsService.trackAutoDeliveryOrderButtonClick(
            analyticsEventValues.REACTIVATE,
            analyticsEventValues.PAUSED
        );
    };

    useEffect(() => {
        amplitudeAutodeliveryTracking.trackAutoDeliveryOrderScreen(analyticsEventValues.PAUSED);
        googleAnalyticsService.trackAutoDeliveryOrderScreen(analyticsEventValues.PAUSED);
    }, []);

    const onClose = () => dispatch(hideAutoDeliveryStatusInactiveDetailsPopup());

    return (
        <AutoDeliveryDetailsStatusNoneTemplate
            banner={banner}
            headerKey={AUTO_DELIVERY_DETAILS_INACTIVE_HEADER_TITLE}
            benefitsItemName='benefitsInactiveTitle'
            howItWorksItemName='howItWorksInactiveTitle'
            benefitsList={benefitsList}
            howItWorksList={howItWorksList}
            amplitudeEvent={amplitudeEvent}
            onClose={onClose}
        />
    );
};

export default AutoDeliveryStatusInactiveDetailsPopup;
